module.exports = __webpack_public_path__ + "static/img/partner.dab074f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner.png
// module id = ZQgY
// module chunks = 0